var objectProto = Object.prototype;

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
  return value === proto;
}

var _isPrototype = isPrototype;
export { _isPrototype as _ };